<template functional>
  <div class="ui padded grid">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'PageView'
}
</script>

<style scoped>

</style>
